// Component Layout
export const HEADER_HEIGHT = "3.5rem";

// Device Viewport Layout
export const SMALL_PHONE_MAX_WIDTH = "340px"; // for low viewport width phones eg Galaxy Fold/Samsung Galaxy models
export const PHONE_MIN_WIDTH = "576px";
export const TABLET_MIN_WIDTH = "800px";
export const DESKTOP_MIN_WIDTH = "992px";
export const LARGE_DESKTOP_MIN_WIDTH = "1200px";
